export const formatDateTime = (date, time) => {
  const timeAsArray = time.split(':');
  const suffix = Number(timeAsArray[0]) < 12 ? 'A.M.' : 'P.M.';
  const displayHour = Number(timeAsArray[0]) % 12 === 0 ? '12' : Number(timeAsArray[0]) % 12;

  return `${date.toDateString()} at ${displayHour}:${timeAsArray[1]} ${suffix}`;
};
